import {Injectable} from "@angular/core";
import {TrustPayService} from "./trust-pay.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {DataListModel} from "./models/data-list-model";
import {TrustPayTransaction} from "./dto/trustPayTransaction";

@Injectable({
  providedIn: 'root'
})
export class TrustPayUnlinkedService extends TrustPayService {

  constructor(http: HttpClient) {
    super(http);
  }

  readonly apiPath2 = 'trustpay/unlinked/';

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string) {
    const params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set( 'sortDirection', sortDirection )
      .set( 'someAdditionalData', someAdditionalData );
    return this.http.get(this.apiPath2, { params }) as Observable<DataListModel<TrustPayTransaction>>;
  }

}

